exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media screen and (min-width: 768px){\r\n  .login-page {\r\n      margin-top: 100px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 768px){\r\n  .login-page {\r\n      margin-top: 70px;\r\n  }\r\n  .login-body{\r\n    width: 95%;\r\n  }\r\n}\r\n\r\n#top-gap {\r\n    padding-top: 134px;\r\n}\r\n\r\n/*----------------------------*\\\r\nBreadcrumb\r\n\\*----------------------------*/\r\n\r\n#breadcrumb {\r\n-webkit-box-shadow: 0px 6px 6px -6px rgba(0, 0, 0, 0.175);\r\nbox-shadow: 0px 6px 6px -6px rgba(0, 0, 0, 0.175);\r\n}\r\n\r\n.breadcrumb {\r\nbackground-color: transparent;\r\nborder: none;\r\nborder-radius: 0px;\r\npadding: 15px 0px;\r\nmargin: 0;\r\nfont-size: 18px;\r\n}\r\n\r\n.breadcrumb>.active {\r\ncolor: #ff1800;\r\n}\r\n\r\n.breadcrumb>li+li:before {\r\ncolor: #DADADA;\r\n}\r\n\r\n@media only screen and (max-width: 991px) {\r\n\r\n\t#top-gap {\r\n    padding-top: 68px;\r\n}}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Ajatus WorkSpace/Now Grocery/now-grocery/NowGroceryStoreFront/src/app/components/signup/signup.component.css
// module id = ../../../../../src/app/components/signup/signup.component.css
// module chunks = main